export default __webpack_public_path__ + "static/BtnBorderLG-b32f9aff0f53b8eb51efae495356cc12.png";